import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Link } from "react-router-dom";
import classes from "./Profile.module.css";

const Address = (props) => {
  const [address, setAddress] = useState([
    {
      id: 1,
      address: "6 October - Zone 6",
      street: "Bank Street - Front Institute Syaha W Fnad2",
      building: "Building 1",
      flat: "Flat 10",
    },
    {
      id: 2,
      address: "6 October - Zone 6",
      street: "Bank Street - Front Institute Syaha W Fnad2",
      building: "Building 1",
      flat: "Flat 10",
    },
    {
      id: 3,
      address: "6 October - Zone 6",
      street: "Bank Street - Front Institute Syaha W Fnad2",
      building: "Building 1",
      flat: "Flat 10",
    },
  ]);
  return (
    <div className={classes.profileAddress}>
      <div className={classes.profileAddress}>
        {address.map((row, index) => {
          return (
            <div className={classes.addressRow}>
              <div className={classes.addressRowTitle}>Address {index + 1}</div>
              <div className={classes.addressRowValue}>
                <div>{row.address}</div>
                <div>{row.street}</div>
                <div>{row.building}</div>
                <div>{row.flat}</div>
                <div className={classes.addressActions}>
                  <button className={classes.addressActionBtn}>
                    <span className={`icon-edit mr-1`}></span>Edit
                  </button>
                  <button className={`ml-3 mr-3 ${classes.addressActionBtn}`}>
                    <span className={`icon-trash mr-1`}></span>Delete
                  </button>
                </div>
              </div>
            </div>
          );
        })}
        <div className={classes.addNewAddress}>
          <button className={`main-button ${classes.addressActionBtn}`}>
            <span className={`icon-plus mr-1`}></span> Add New Address
          </button>
        </div>
      </div>
    </div>
  );
};

export { Address };
